import React, { useMemo, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactGA from "react-ga4";

import {
  getEstados,
  getConcesionarios,
} from "../../../../API/CitasServicioRequest/index";
import {
  getCiudades,
  getAudicodeInfo,
  sendMailConfiguradorConcesionaria,
  sendMailConfiguradorCliente,
  sendLead,
} from "../../../../API/ConfiguradorRequest/index";

import {
  setTratoAction,
  setNombreAction,
  setApellidoPaternoAction,
  setCorreoAction,
  setTelefonoAction,
  setMovilAction,
  setIdConcesionarioAction,
  setEstadoAction,
  setCiudadAction,
  setConcesionarioAction,
  setComentariosAction,
  setAvisosDePrivacidadAction,
  setTerminosCondicionesAction,
  setDatos1Action,
  setDatos2Action,
  setModelInfoAction,
  reiniciarStateAction
} from "../../../../actions/configuradorActions";

import ROUTES from "../../../../utilities/Routes";
import { getOnlyAudiCenters, obtenerFecha, scrollToInput } from "../../../../utilities/utils";

import ReactLoading from "react-loading";

import {
  isOnlyNumbers,
} from "../../../../utilities/Validations";
import { useNavigate, useSearchParams } from "react-router-dom";

import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import ButtonBack from "../../../../components/Buttons/Back";
import { sendLeadToSaas } from "../../../../API/SaasRequest";
import { validarApellidoPaterno, validarCelular, validarCorreo, validarNombre, validarTelefono, validarCorreo2, validarCodigoPostal } from "../../../../utilities/Validations/lead";
import { TratoComponent } from "../../../../components/Form/Trato";
import TradeInSection from "../../../../components/Form/TradeInSection";
import { sendTradeIn } from "../../../../API/TradeInRequest";

const FormAudiConfigurador = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [acIsValid, setAcIsValid] = useState(true);

  let navigate = useNavigate();

  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [concesionarios, setConcesionarios] = useState([]);
  const [codigoPostal, setCodigoPostal] = useState("");

  const [showErrorEstado, setErrorEstado] = useState(false);
  const [showErrorCiudad, setErrorCiudad] = useState(false);
  const [showErrorConcesionario, setErrorConcesionario] = useState(false);
  const [showErrorComentarios, setErrorComentarios] = useState(false);
  const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);

  const [tradeInData, setTradeInData] = useState(null);

  const [showErrorLead, setErrorLead] = useState(false);
  const configuradorObj = useSelector((state) => state.configurador);

  const filterCiudades = useMemo(() => {
    if (estados.length > 0 && ciudades.length > 0) {
      const estadoSelected = estados.find(
        (edo) => edo.nombreedo === configuradorObj.estado
      );

      if (estadoSelected === undefined) return [];

      return ciudades.filter(
        (cd) => cd.idestado.idestado === estadoSelected.idestado
      );
    }
    return [];
  }, [configuradorObj.estado, estados, ciudades]);

  const filterConcesionarios = useMemo(() => {
    if (concesionarios.length > 0 && estados.length > 0) {
      const estadoSelected = estados.find(
        (cd) => cd.nombreedo === configuradorObj.estado
      );

      if (estadoSelected === undefined) return [];

      return concesionarios.filter(
        (concesionario) => concesionario.stateName === estadoSelected.nombreedo
      );
    }
    return [];
  }, [configuradorObj.estado, estados, concesionarios]);

  const setTato = (inTrato) => {
    dispatch(setTratoAction(inTrato));
  };
  const setNombre = (inNombre) => {
    dispatch(setNombreAction(inNombre));
  };
  const setApellidoPaterno = (inApellidoPaterno) => {
    dispatch(setApellidoPaternoAction(inApellidoPaterno));
  };
  const setCorreo = (inCorreo) => {
    dispatch(setCorreoAction(inCorreo));
  };
  const setTelefono = (inTelefono) => {
    dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
  };
  const setMovil = (inMovil) => {
    dispatch(setMovilAction(isOnlyNumbers(inMovil)));
  };
  const setIdConcesionario = (inIdConcesionario) => {
    dispatch(setIdConcesionarioAction(inIdConcesionario));
  };
  const setConcesionario = (inConcesionario) => {
    dispatch(setConcesionarioAction((inConcesionario)));
  };
  const setEstado = (inEstado) => {
    dispatch(setEstadoAction(inEstado));
  };
  const setCiudad = (inCiudad) => {
    dispatch(setCiudadAction(inCiudad));
  };
  const setComentarios = (inComentarios) => {
    dispatch(setComentariosAction(inComentarios));
  };
  const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
    dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
  };
  const setTerminosCondiciones = (inTerminosCondiciones) => {
    dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
  };
  const setDatos1 = (inDatos1) => {
    dispatch(setDatos1Action(inDatos1));
  };
  const setDatos2 = (inDatos2) => {
    dispatch(setDatos2Action(inDatos2));
  };
  const setModelInfo = (inModelInfo) => {
    dispatch(setModelInfoAction(inModelInfo));
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const validated = validateForm();

    if (validated) {
      setLoadingSubmit(true);
      const objSubmit = {
        tratamiento: configuradorObj.trato,
        nombre: configuradorObj.nombre,
        apellidoPaterno: configuradorObj.apellidoPaterno,
        apellidoMaterno: configuradorObj.apellidoMaterno,
        email: configuradorObj.correo,
        telefono: configuradorObj.telefono,
        celular: configuradorObj.movil,
        provincia: configuradorObj.estado,
        ciudad: configuradorObj.ciudad,
        concesionariaPreferida: configuradorObj.concesionario,
        fuenteSitioWeb: "Sitio Web Audi",
        marca: "Audi",
        tipoRegistro: "Importador",
        fuenteSecundaria: "Medios Digitales Importador",
        tercerNivel: "Sitio Web Audi - configurador",
        llaveOrigen: "AUSW" + new Date().getTime(),
        vehiculoActual: "",
        permisoTransferenciaDatos: configuradorObj.datos1,
        permisoContactoMarketing: configuradorObj.datos2,
        urlWeb: "http://www.audi.com.mx/",
        tipoCita: "Quiero comprar un Audi nuevo",
        fechaNacimiento: "",
        numeroConcesionaria:
          configuradorObj.idConcesionario < 1000
            ? "0" + configuradorObj.idConcesionario
            : "" + configuradorObj.idConcesionario,
        horarioPreferente: "",
        fechaPreferente: "",
        vehiculoInteres: "",
        urlPrivacidad: "http://www.audi.com.mx/mx/web/es.html",
        sexo: configuradorObj.trato === "Sr" ? "Masculino" : "Femenino",
        status: "Nuevo",
        descripcion: searchParams.get("ac") + " - " + (configuradorObj.comentarios.trim() === "" ? "Sin comentarios" : configuradorObj.comentarios.trim()),
        fbCampaignID: "",
      };

      const dealerActualPage = concesionarios.find(
        (dealer) => dealer.dealerNumber === configuradorObj.idConcesionario
      );

      if (dealerActualPage.contactos !== null) {
        let dealerUrls =
          dealerActualPage.contactos.split(",").length > 8
            ? dealerActualPage.contactos
              .split(",")[4]
              .split(";")
              .map((item) => item.trim())
            : "";

        const obtep = {
          ...configuradorObj,
          permisoTransferenciaDatos: configuradorObj.datos1,
          permisoContactoMarketing: configuradorObj.datos2,
          dealerUrls,
          ac: searchParams.get("ac"),
          fecha: obtenerFecha(),
          comentarios: configuradorObj.comentarios.trim() === "" ? "Sin comentarios" : configuradorObj.comentarios.trim(),
        };

        sendLead(objSubmit)
          .then((response) => {
            setLoadingSubmit(false);
            sendMailConfiguradorConcesionaria(obtep);
            sendMailConfiguradorCliente(obtep);
            handleSendLeadToSaas(objSubmit, response?.data?.idTransaccion, true, obtep.ac, response?.data?.message);

            ReactGA.event('lead_sended', {
              category: "Configurador",
              action: "Lead enviado exitosamente",
              label: "Nuevo Lead Configurador", // optional
              once: true // Solo se envia una vez
            });

            if (tradeInData) {
              const tradeInPayload = {
                personal_info: {
                  nombre: configuradorObj.nombre,
                  apellidoPaterno: configuradorObj.apellidoPaterno,
                  apellidoMaterno: "",
                  email: configuradorObj.correo,
                  celular: configuradorObj.movil,
                  codigoPostal: codigoPostal,
                },
                car_info: {
                  trimid: "v_1_4_1_9_1",
                  valorpropuesto: 0,
                  ...tradeInData,
                },
                permisoContactoMarketing: objSubmit.permisoContactoMarketing,
                permisoTransferenciaDatos: objSubmit.permisoTransferenciaDatos,
                numeroConcesionaria: configuradorObj.numeroConcesionaria,
                idMarca: 4,
              };
              sendTradeIn(tradeInPayload)
                .then((res) => console.log("Trade-in enviado:", res))
                .catch((err) => console.error("Error trade-in:", err));
            }

            redirigirThankYouPage();

          })
          .catch((e) => {
            handleSendLeadToSaas(objSubmit, e?.response?.data?.idTransaccion || null, false, obtep.ac, e?.response?.data?.message || e?.message || "Error en envío de lead");
            setLoadingSubmit(false);
            setErrorLead(true);
            console.log(e);
          });
      }
    }
  };

  const handleSendLeadToSaas = (lead, idTransaccion, status, ac, message) => {
    sendLeadToSaas(lead, process.env.REACT_APP_CONFIGURADOR_FORM_ID, idTransaccion, status, `Audicode - ${ac}`, message)
      .then(respuesta => {
        // manejar respuesta
      })
      .catch(error => {
        // manejar error
        console.error("Error en log: " + error)
      });
  }

  const validateForm = () => {

    if (validarNombre(configuradorObj.nombre) === false) {
      scrollToInput("nombre");
      return false
    }
    if (validarApellidoPaterno(configuradorObj.apellidoPaterno) === false) {
      scrollToInput("apellidoPaterno");
      return false
    }
    if (validarTelefono(configuradorObj.telefono) === false) {
      scrollToInput("telefono");
      return false;
    }
    if (validarCorreo(configuradorObj.correo) === false) {
      scrollToInput("correo");
      return false
    }
    if (validarCelular(configuradorObj.movil) === false) {
      scrollToInput("movil");
      return false;
    }
    if (configuradorObj.estado === "") {
      scrollToInput("estado");
      setErrorEstado(true);
      return false;
    } else {
      setErrorEstado(false);
    }
    if (configuradorObj.ciudad === "") {
      scrollToInput("ciudad");
      setErrorCiudad(true);
      return false;
    } else {
      setErrorCiudad(false);
    }
    if (configuradorObj.comentarios.length > 1000) {
      scrollToInput("comentarios");
      setErrorComentarios(true);
      return false;
    } else setErrorComentarios(false);

    if (configuradorObj.idConcesionario === "") {
      scrollToInput("concesionario");
      setErrorConcesionario(true);
      return false
    } else {
      setErrorConcesionario(false);
    }
    if (
      configuradorObj.avisoPrivacidad === false ||
      configuradorObj.terminosCondiciones === false ||
      configuradorObj.datos1 === false ||
      configuradorObj.datos2 === false
    ) {
      setErrorDeclaraciones(true);
      return false;
    } else setErrorDeclaraciones(false);

    return true;
  };

  useEffect(() => {
    document.title = "Formulario - Configurador";
    window.scrollTo(0, 0);
    dispatch(reiniciarStateAction())

    if (process.env.REACT_APP_ENABLE_GA4 === "true") {
      // Se inicializa el objeto de analytics para el sitio
      ReactGA.initialize(process.env.REACT_APP_CONFIGURADOR_GA_ID);
    }

    const mapData = (data) => {
      const { configurationDetails } = data;
      const { carline } = configurationDetails;
      const { model } = configurationDetails;
      const { techdata } = configurationDetails;
      const { equipments } = configurationDetails;
      const { equipmentList } = equipments;
      const media = configurationDetails.configurationMedia.find(
        (item) => item.type === "exterior_front"
      );
      const exteriorColor = equipmentList.find(
        (item) => item.type === "exterior_color"
      );

      const { headlines } = techdata;

      const prestaciones = headlines.find(
        (item) => item.id === "performance-data"
      );
      const topSpeed = prestaciones.items.find(
        (item) => item.id === "top-speed"
      );
      const acceleration = prestaciones.items.find(
        (item) => item.id === "acceleration"
      );

      const driveline = headlines.find((item) => item.id === "driveline");
      const transmision = driveline ? driveline.items.find((item) => item.id === "gearbox") : { value: "N/A" };

      setModelInfo({
        carline,
        model,
        topSpeed: topSpeed || { value: "N/A", unit: "" },
        acceleration,
        media,
        transmision,
        exteriorColor,
      });
    };
    const funGetAudicodeInfo = async (audicode) => {
      getAudicodeInfo(audicode).then((response) => {
        const state =
          response.data.data[0]?.configurationMetaInformation
            .configurationState;

        if ("VALID" === state) {
          window.scrollTo(0, 0);
          const data = response.data.data[0];
          mapData(data);
        } else {
          setAcIsValid(false);
        }
        setLoading(false);
      });
    };
    const funGetEstado = async () => {
      getEstados().then((responseEstados) => {
        setEstados(responseEstados.data);
      });
    };

    const funGetCiudades = async () => {
      getCiudades().then((responseCiudades) => {
        setCiudades(responseCiudades.data);
      });
    };

    const funGetConcesionarios = async () => {
      getConcesionarios().then((responseConcesionarios) => {
        const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);

        setConcesionarios(filterConcesionarios);
      });
    };

    funGetAudicodeInfo(searchParams.get("ac"));
    funGetConcesionarios();
    funGetCiudades();
    funGetEstado();
  }, []); // eslint-disable-line

  const redirigirThankYouPage = () => {
    navigate(ROUTES.AUDICONFIGURADORTHANKYOUEMPY);
  };

  if (!acIsValid)
    return (
      <div className="loading-g d-vertical-center loading-btn mb-5">
        <div>
          <span>El Audicode no es valido {searchParams.get("ac")}</span>
        </div>
      </div>
    );

  if (loading)
    return (
      <div
        className="loading-g d-vertical-center loading-btn mb-5"
        style={{ height: "calc(100vh - 72px)" }}
      >
        <div>
          <ReactLoading
            type="cylon"
            color="#000"
            width={"100%"}
            height={"58px"}
          />
          <span> Cargando...</span>
        </div>
      </div>
    );

  return (
    <>
      <main className="container configurador">
        <section className="w-100 position-relative">
          <h2
            className="position-absolute px-md-1 configurador-float-title"
          >
            Adquiere ya tu nuevo Audi
          </h2>
          <img
            className="w-100 mt-5 mt-md-0"
            style={{ minHeight: "220px", maxHeight: "55vh", objectFit: "contain", aspectRatio: '5/3' }}
            src={configuradorObj?.modelinfo?.media?.url}
            alt="Configurador"
          />
        </section>
        <section className="w-100 ps-2">
          <ButtonBack pagesToBack={1}></ButtonBack>
        </section>
        <section className="w-100 p-2 p-md-5 pb-md-2">
          <h4 className="mt-4 mb-3 mt-md-0 mb-md-3" style={{ fontFamily: "AudiTypeExt" }}>
            Estás muy cerca de obtener tu nuevo
          </h4>
        </section>
        <section className="w-100 d-flex flex-column flex-md-row gap-2 justify-content-between align-items-lg-center p-2 p-md-5 pt-md-2 pb-md-2">
          <div className="">
            <h1 className="pt-2">{configuradorObj?.modelinfo?.carline?.name}</h1>
            <span>{configuradorObj?.modelinfo?.model?.name}</span>
          </div>
          <div className="d-flex gap-4 justify-content-between align-items-md-center mt-3">
            <div className="col text-center flex-fill">
              <h5 style={{ fontFamily: "AudiTypeExt" }}>
                {configuradorObj?.modelinfo?.acceleration?.value +
                  configuradorObj?.modelinfo?.acceleration?.unit}
              </h5>
              <span>Aceleración</span>
            </div>
            <div className="col text-center flex-fill">
              <h5 style={{ fontFamily: "AudiTypeExt" }}>
                {configuradorObj?.modelinfo?.topSpeed?.value +
                  configuradorObj?.modelinfo?.topSpeed?.unit}
              </h5>
              <span className="d-none d-md-block">Velocidad máxima</span>
              <span className="d-block d-md-none">Velocidad máx.</span>
            </div>
            <div className="col text-center flex-fill">
              <h5 style={{ fontFamily: "AudiTypeExt" }}>
                {configuradorObj?.modelinfo?.transmision?.value}
              </h5>
              <span>Transmisión</span>
            </div>
          </div>
        </section>
        <section className="w-100 p-2 p-md-5 pt-md-2">
          <h2 className="w-100 text-start mt-5 mb-5 pt-2 pb-3 mt-md-4">
            Por favor, completa el siguiente formulario para ser atendido por un
            concesionario Audi.
          </h2>
          <form className="w-100" onSubmit={onSubmit}>
            <TratoComponent h="h2" value={configuradorObj.trato} onChange={(e) => { setTato(e.target.value) }} />
            <section className="fields-grid mb-5">
              <div className="order-1">
                <InputText
                  label="Nombre"
                  name="nombre"
                  maxLength="40"
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    e.target.value = value;
                    setNombre(value);
                  }}
                  validator={validarNombre}
                  errorMessage={configuradorObj.nombre.length > 40 ? "Máx. 40 cáracteres" : "Carácter no válido, por favor use solo letras."}
                />
              </div>

              <div className="order-2">
                <InputText
                  label="Apellido Paterno"
                  name="apellidoPaterno"
                  maxLength="80"
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    e.target.value = value;
                    setApellidoPaterno(value);
                  }}
                  validator={validarApellidoPaterno}
                  errorMessage={configuradorObj.apellidoPaterno.length > 80 ? "Máx. 80 cáracteres" : "Carácter no válido, por favor use solo letras."}
                />
              </div>
              <div className="order-3 order-lg-4">
                <InputText
                  label="Correo electrónico"
                  name="correo"
                  value={configuradorObj.correo}
                  onChange={(e) => {
                    if (e.target.value.length <= 80)
                      setCorreo(e.target.value);
                  }}
                  maxLength="80"
                  validator={validarCorreo}
                  errorMessage={validarCorreo2(configuradorObj.correo) ? "Por favor use un e-mail válido con formato: nombre@dominio.com" : "No se admiten caracteres especiales como : ,á!$%&Ö"}
                />
              </div>
              <div className="order-4 order-lg-3">
                <InputText
                  label="Télefono"
                  name="telefono"
                  value={configuradorObj.telefono}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      setTelefono(e.target.value);
                    }
                  }}
                  validator={validarTelefono}
                  errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                />
              </div>
              <div className="order-5">
                <InputText
                  label="Móvil"
                  name="movil"
                  value={configuradorObj.movil}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      setMovil(e.target.value)
                    }
                  }}
                  validator={validarCelular}
                  errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                />

              </div>
              <div className="order-5">
                <InputText
                  label="Código Postal"
                  name="codigoPostal"
                  value={codigoPostal}
                  onChange={(e) => {
                    if (e.target.value.length <= 5) {
                      setCodigoPostal(e.target.value)
                    }
                  }}
                  validator={validarCodigoPostal}
                  errorMessage="Introduzca un código postal válido."
                />
              </div>
            </section>
            <section className="pt-5">
              <h2 className="pb-3">Selecciona un concesionario:</h2>
              <div className="d-flex gap-5 flex-column flex-xl-row">
                <div className="w-100 w-xl-50 d-flex flex-column gap-5">
                  <div>
                    <InputSelect
                      label="Estado"
                      name="estado"
                      options={estados.map((item, i) => ({
                        value: item.nombreedo,
                        label: item.nombreedo,
                      }))}
                      onChange={(e) => {
                        setCiudad("")
                        setIdConcesionario("");
                        setConcesionario("");
                        setEstado(e.target.value);
                        setErrorEstado(false);
                      }}
                      showError={showErrorEstado}
                      defaultValue={configuradorObj.estado}
                    />
                  </div>
                  <div>
                    <InputSelect
                      label="Ciudad"
                      name="ciudad"
                      options={filterCiudades.map((item, i) => ({
                        value: item.nombrecd,
                        label: item.nombrecd,
                      }))}
                      disabled={configuradorObj.estado === ""}
                      onChange={(e) => {
                        setCiudad(e.target.value)
                        setErrorCiudad(false);
                      }}
                      value={
                        configuradorObj.ciudad === ""
                          ? ""
                          : configuradorObj.ciudad
                      }
                      showError={showErrorCiudad}
                      defaultValue={configuradorObj.ciudad}
                    />
                  </div>
                  <div>
                    <InputSelect
                      label="Concesionario"
                      errorMessage="Por favor, selecciona un concesionario."
                      name="concesionario"
                      options={filterConcesionarios.map((item, i) => ({
                        value: item.dealerNumber,
                        label: item.name,
                      }))}
                      disabled={configuradorObj.estado === ""}
                      onChange={(e) => {
                        const concesionario = concesionarios.find(
                          (con) => con.dealerNumber === parseInt(e.target.value)
                        );

                        setIdConcesionario(concesionario.dealerNumber);
                        setConcesionario(concesionario.name);
                        setErrorConcesionario(false);
                      }}
                      showError={showErrorConcesionario}
                      noDataMessage={configuradorObj.estado === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                      showNoDataMessage={configuradorObj.estado !== ""}
                      defaultValue={configuradorObj.idConcesionario}
                    />
                  </div>
                </div>
                <div className="w-100 w-xl-50">
                  <textarea
                    className="form-control cs-input in-textarea"
                    id="comentarios"
                    rows="5"
                    maxLength="1000"
                    placeholder="Comentarios"
                    onChange={(e) => setComentarios(e.target.value)}
                    value={configuradorObj.comentarios}
                    name="comentarios"
                  ></textarea>
                  <span>Máx. 1.000 caracteres</span>
                  <br></br>
                  <span
                    className={`inValid-input ${!showErrorComentarios ? "d-none" : ""
                      }`}
                  >
                    Tu comentario tiene más de 1.000 caracteres
                  </span>
                </div>
              </div>
            </section>

            <TradeInSection onTradeInChange={setTradeInData} />

            <section className="w=100 mt-5">
              <h2 className="w-100 text-start">
                Declaraciones de conformidad relativas a la protección de datos
              </h2>
              <p className="mt-4 mb-5">
                Para poder ofrecerte de ahora en adelante el mejor asesoramiento
                posible y para poder enviarte información sobre nuevos productos
                y servicios necesitamos tu consentimiento.
              </p>
              <div className="col-12 mb-3 ">
                <InputCheckBox
                  id="radio-aceptar-todo"
                  rounded
                  label="Aceptar todo"
                  onChange={(e) => {
                    var checkboxes =
                      document.getElementsByName("checkboxgroup");

                    checkboxes.forEach((cbx) => {
                      cbx.checked = e.target.checked;
                    });

                    setAvisosDePrivacidad(e.target.checked);
                    setTerminosCondiciones(e.target.checked);
                    setDatos1(e.target.checked);
                    setDatos2(e.target.checked);

                  }}
                />
              </div>
              <div className="col-12 mb-4 mb-md-3">
                <InputCheckBox
                  name="checkboxgroup"
                  onChange={(e) => {
                    var radio = document.getElementById("radio-aceptar-todo");

                    if (e.target.checked === false) {
                      radio.checked = false;
                    }
                    setAvisosDePrivacidad(e.target.checked);
                  }}
                >
                  <span>
                    He leído y acepto el{" "}
                    <a
                      href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Aviso de Privacidad.
                    </a>
                  </span>
                </InputCheckBox>
              </div>
              <div className="col-12 mb-4 mb-md-3">
                <InputCheckBox
                  name="checkboxgroup"
                  onChange={(e) => {
                    var radio = document.getElementById("radio-aceptar-todo");

                    if (e.target.checked === false) {
                      radio.checked = false;
                    }
                    setTerminosCondiciones(e.target.checked);
                  }}
                >
                  <span>
                    He leído y acepto el{" "}
                    <a
                      href="https://www.audi.com.mx/es/tools/navigation/layer/imprint/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Términos y Condiciones.
                    </a>
                  </span>
                </InputCheckBox>
              </div>
              <div className="col-12 mb-4 mb-md-3">
                <InputCheckBox
                  label="Acepto que mis datos personales aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, a efecto."
                  name="checkboxgroup"
                  onChange={(e) => {
                    var radio = document.getElementById("radio-aceptar-todo");

                    if (e.target.checked === false) {
                      radio.checked = false;
                    }
                    setDatos1(e.target.checked);
                  }}
                />
              </div>
              <div className="col-12 mb-4 mb-md-3">
                <InputCheckBox
                  label="Acepto que mis datos personales aquí proporcionados sean
                  transferidos a Facebook Mexico S. de R.L. de C.V., Twitter,
                  Inc. y Google Operaciones de México, S. DE R.L. DE C.V., para
                  efectos de marketing."
                  name="checkboxgroup"
                  onChange={(e) => {
                    var radio = document.getElementById("radio-aceptar-todo");

                    if (e.target.checked === false) {
                      radio.checked = false;
                    }
                    setDatos2(e.target.checked);
                  }}
                />
                <span
                  className={`inValid-input ${!showErrorDeclaraciones ? "d-none" : ""
                    }`}
                >
                  Para continuar, acepte nuestras declaraciones de conformidad.
                </span>
              </div>

              {!loadingSubmit ? (
                <button className={`button-enviar mt-5 mb-5`} type="submit">
                  Enviar
                </button>
              ) : (
                <button
                  className="button-enviar disabled"
                  type="button"
                  disabled={true}
                >
                  <div className="loading-g loading-send loading-btn">
                    <div>
                      <ReactLoading
                        type="cylon"
                        color="#fff"
                        width={"100%"}
                        height={"58px"}
                      />
                    </div>
                  </div>
                </button>
              )}
              <span
                className={`inValid-input d-block ${!showErrorLead ? "d-none" : ""
                  }`}
              >
                Hubo un eror. Intentelo más tarde
              </span>
            </section>
          </form>
        </section>
      </main>
    </>
  );
};

export default FormAudiConfigurador;
